// Minimal jQuery plugins matching Bootstrap 3's $.fn.tooltip and $.fn.popover APIs.
// Drop-in replacement that preserves the class transitions, events, and data API
// consumed by modal_popup_dir.js, text_dir.js, and popover_interactive_dir.js.
/* global jQuery */
(function ($) {
    // -----------------------------------------------------------------------
    // $.fn.tooltip — no-op shim (Angular UI Bootstrap provides its own tooltips;
    // no code calls the jQuery tooltip API directly)
    // -----------------------------------------------------------------------
    $.fn.tooltip = function () {
        return this;
    };

    // -----------------------------------------------------------------------
    // $.fn.popover — used by modal_popup_dir.js and text_dir.js
    // -----------------------------------------------------------------------
    class Popover {
        constructor(element, options) {
            this.element = element;
            this.$element = $(element);
            this.options = $.extend(
                {
                    container: 'body',
                    placement: 'bottom',
                    html: false,
                    trigger: 'manual',
                    content: '',
                },
                options,
            );
            this._tip = null;
            this._isShown = false;
            this._bindTrigger();
        }

        _bindTrigger() {
            if (this.options.trigger === 'hover') {
                this.$element.on('mouseenter.bs.popover', () => this.show());
                this.$element.on('mouseleave.bs.popover', () => this.hide());
            }
        }

        tip() {
            if (!this._tip) {
                this._tip = $(
                    '<div class="popover fade" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
                );
            }
            return this._tip;
        }

        show() {
            if (this._isShown) return;
            this._isShown = true;

            const tip = this.tip();
            const content = typeof this.options.content === 'function' ? this.options.content() : this.options.content;

            const contentEl = tip.find('.popover-content');
            if (this.options.html) {
                contentEl.html('').append(content);
            } else {
                contentEl.text(content);
            }

            tip.removeClass('top bottom left right').addClass(this._resolvedPlacement());

            const container = this.options.container === 'body' ? $(document.body) : $(this.options.container);
            tip.detach().appendTo(container);
            tip.css('display', 'block');

            this._position();
            tip.addClass('in');

            this.$element.trigger('shown.bs.popover');
        }

        hide() {
            if (!this._isShown) return;
            this._isShown = false;

            const tip = this.tip();
            tip.removeClass('in');
            // Remove after transition
            setTimeout(() => {
                tip.detach();
                this.$element.trigger('hidden.bs.popover');
            }, 150);
        }

        toggle() {
            if (this._isShown) {
                this.hide();
            } else {
                this.show();
            }
        }

        destroy() {
            this.hide();
            this.$element.off('.bs.popover');
            this.$element.removeData('bs.popover');
            if (this._tip) {
                this._tip.remove();
                this._tip = null;
            }
        }

        _resolvedPlacement() {
            const p = this.options.placement;
            // Simplify compound placements (e.g., 'bottom-right' → 'bottom')
            return p.split('-')[0] || 'bottom';
        }

        _position() {
            const tip = this.tip()[0];
            const el = this.element;
            const placement = this._resolvedPlacement();

            const elRect = el.getBoundingClientRect();
            const tipRect = tip.getBoundingClientRect();

            // The tip is absolutely positioned inside its container. Subtract the
            // container's document-relative offset so the tip aligns with the trigger.
            const container = tip.offsetParent || document.body;
            const containerRect = container.getBoundingClientRect();
            const offsetTop = containerRect.top + window.scrollY;
            const offsetLeft = containerRect.left + window.scrollX;

            let top;
            let left;

            switch (placement) {
                case 'top':
                    top = elRect.top + window.scrollY - tipRect.height - offsetTop;
                    left = elRect.left + window.scrollX + (elRect.width - tipRect.width) / 2 - offsetLeft;
                    break;
                case 'bottom':
                    top = elRect.bottom + window.scrollY - offsetTop;
                    left = elRect.left + window.scrollX + (elRect.width - tipRect.width) / 2 - offsetLeft;
                    break;
                case 'left':
                    top = elRect.top + window.scrollY + (elRect.height - tipRect.height) / 2 - offsetTop;
                    left = elRect.left + window.scrollX - tipRect.width - offsetLeft;
                    break;
                case 'right':
                    top = elRect.top + window.scrollY + (elRect.height - tipRect.height) / 2 - offsetTop;
                    left = elRect.right + window.scrollX - offsetLeft;
                    break;
                default:
                    top = elRect.bottom + window.scrollY - offsetTop;
                    left = elRect.left + window.scrollX - offsetLeft;
            }

            tip.style.top = `${top}px`;
            tip.style.left = `${left}px`;
            tip.style.position = 'absolute';
        }
    }

    $.fn.popover = function (option) {
        return this.each(function () {
            const $this = $(this);
            let data = $this.data('bs.popover');

            if (typeof option === 'object') {
                if (data) data.destroy();
                data = new Popover(this, option);
                $this.data('bs.popover', data);
            } else if (typeof option === 'string' && data) {
                data[option]();
            }
        });
    };
})(jQuery);
